module.exports = __webpack_public_path__ + "img/ch17_08_旧徽章.5fc2c278.jpg";